import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SignInCard from './SignInCard';
import Content from './Content';
import { Box } from '@mui/material';
import getCustomTheme from '../../../../Theme/CustomTheme';

export default function SignInSide() {
  const [showCustomTheme, setShowCustomTheme] = React.useState(true);
  
  const defaultTheme = createTheme({ palette: { mode: 'light' } });
  const SignInSideTheme = createTheme(getCustomTheme('light'));

  return (
    <Box
      sx={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, hsla(210,98%,90%,0.6) 0%, rgba(255, 255, 255, 1) 60%)', // Brand-blue tinted gradient
        animation: 'fadeIn 1.5s ease-in-out',
        '@keyframes fadeIn': {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
      }}
    >
      {/* Use the default theme with light mode */}
      <ThemeProvider theme={showCustomTheme ? SignInSideTheme : defaultTheme}>
        <CssBaseline />
        <Stack
          direction="column"
          component="main"
          sx={{
            justifyContent: 'space-between',
            height: { xs: 'auto', md: '100%' },
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: 2,
              m: 'auto',
            }}
          >
            <Content />
            <SignInCard />
          </Stack>
        </Stack>
      </ThemeProvider>
    </Box>
  );
}
